<db-dialog-wrapper [fullScreen]="true" [dialog]="this" [hasCloseButton]="false" [canClose]="true">
  <div class="db-small-screen-disclaimer-wrap" >
<!--
    <div class="db-small-screen-disclaimer-header"><img src="assets/images/logos/10web_name_logo_dark-new.svg"/></div>
-->
    <div class="db-small-screen-disclaimer-body">
      <div class="db-small-screen-disclaimer-body-text">
        <div class="db-small-screen-disclaimer-body-text-title">Use a Desktop device<br/>to get best 10Web experience</div>
        <div class="db-small-screen-disclaimer-body-text-desc">Check your inbox for a magic link<br/>to sign in to 10Web with 1 click</div>
      </div>
      <div class="db-small-screen-disclaimer-body-img">
        <iframe width="100%" height="100%" [src]="url | safe" frameborder="0" allow="autoplay" allowfullscreen></iframe>
      </div>

      <p class="db-small-screen-disclaimer-body-close" (click)="close()">No, I want to continue on mobile</p>
    </div>
  </div>
</db-dialog-wrapper>
